import { useOfficialStore } from '$/store/useOfficialStore';

const BACK_URL = {
  // development: process.env.NEXT_PUBLIC_REBONEO_SERVER_URL?.includes('localhost') ? 'https://ai-engine-gateway-pre-roboneo.meitu.com' : `${process.env.NEXT_PUBLIC_REBONEO_SERVER_URL}/ai-engine-gateway`,
  development: 'https://ai-engine-gateway-pre-roboneo.meitu.com',
  dev: 'https://ai-engine-gateway-develop-pre-roboneo.meitu.com',
  pre: 'https://ai-engine-gateway-pre-roboneo.meitu.com',
  beta: 'https://ai-engine-gateway-beta-roboneo.meitu.com',
  release: 'https://ai-engine-gateway-roboneo.meitu.com',
};
// 内网地址
const INTERNAL_BACK_URL = {
  development: 'https://ai-engine-gateway-pre-roboneo-cloud.meitu-int.com',
  dev: 'https://ai-engine-gateway-pre-roboneo-cloud.meitu-int.com',
  pre: 'https://ai-engine-gateway-pre-roboneo-cloud.meitu-int.com',
  beta: 'https://ai-engine-gateway-beta-roboneo-cloud.meitu-int.com',
  release: 'https://ai-engine-gateway-roboneo-cloud.meitu-int.com',
};
const OVERSEA_BACK_URL = {
  development: 'https://ai-engine-gateway-pre-roboai.starii.com',
  dev: 'https://ai-engine-gateway-pre-roboai.starii.com',
  pre: 'https://ai-engine-gateway-pre-roboai.starii.com',
  beta: 'https://ai-engine-gateway-beta-roboai.starii.com',
  release: 'https://ai-engine-gateway-roboai.starii.com',
};
const CANVAS_URL = {
  development: '//prewebapi.roboneo.com',
  dev: '//prewebapi.roboneo.com',
  pre: '//prewebapi.roboneo.com',
  beta: '//betawebapi.roboneo.com',
  release: '//webapi.roboneo.com',
};
const OVERSEA_CANVAS_URL = {
  development: '//prewebapi-roboai.starii.com',
  dev: '//prewebapi-roboai.starii.com',
  pre: '//prewebapi-roboai.starii.com',
  beta: '//betawebapi-roboai.starii.com/',
  release: '//webapi-roboai.starii.com/',
};
const AGENT_TEAM_URL = {
  development: 'https://agent-api-pre-roboneo.meitu.com',
  dev: 'https://agent-api-develop-pre-roboneo.meitu.com',
  pre: 'https://agent-api-pre-roboneo.meitu.com',
  beta: 'https://agent-api-beta-roboneo.meitu.com',
  release: 'https://agent-api-roboneo.meitu.com',
};
const APP = {
  roboneo: {
    token: () => {
      const { token } = useOfficialStore.getState();
      return token;
    },
    baseURL: () => {
      const { env, isOverseaServer = false } = useOfficialStore.getState();
      return isOverseaServer ? OVERSEA_BACK_URL[env] : BACK_URL[env];
    },
    baseInternalURL: () => {
      const { env } = useOfficialStore.getState();
      return INTERNAL_BACK_URL[env];
    },
    // sseBaseUrl: 'http://ai-engine-gateway-pre-roboneo.meitu.com',
    // baseCanvasURL: process.env.REBONEO_CANVAS_SERVER_URL
    baseCanvasURL: () => {
      const { env, isOverseaServer = false } = useOfficialStore.getState();
      return isOverseaServer ? OVERSEA_CANVAS_URL[env] : CANVAS_URL[env];
    },
    baseAgentTeamURL: () => {
      const { env, isOverseaServer = false } = useOfficialStore.getState();
      return isOverseaServer ? AGENT_TEAM_URL[env] : AGENT_TEAM_URL[env];
    },
    api: {
      path: '/roboneo/sync/request',
      initRoom: '/studio/room/init.json',
      saveLayer: '/studio/layer/save.json',
      deleteLayer: '/studio/layer/delete.json',
      layerList: '/studio/layer/list.json',
      taskSubmit: '/studio/task/submit.json',
      fusionImageTaskSubmit: '/studio/task/image_fusion_submit.json', // 融合图片任务提交
      taskList: '/studio/task/list.json',
      taskQuery: '/studio/task/query.json',
      fontList: '/font/list.json',
      videoEditorExportCreate: '/video_editor/export/create.json',
      videoEditorExportQuery: '/video_editor/export/query.json',
      videoEditorExportCancel: '/video_editor/export/cancel.json',
      videoEditorProjectCreate: '/video_editor/project/create.json',
      videoEditorProjectSave: '/video_editor/project/save.json',
      videoEditorProjectList: '/video_editor/project/list.json',
      videoEditorProjectDetail: '/video_editor/project/detail.json',
      taskMark: '/studio/task/mark.json',
      feedback: '/user/feedback.json',
      checkEditImagePrice: '/studio/list_token.json',
      pngToSvg: '/studio/task/png2svg_submit.json',
      cards: '/common/cards.json',
      commonConfig: '/common/config.json',
      checkAiFace: '/studio/task/ai_face.json',
      audioDenoiseTaskSubmit: '/studio/task/ai_audio_spliter.json', // 音频降噪任务提交

      // 节点模式
      initWorkFlow: '/workflow/canvas/init.json',
      saveWorkFlow: '/workflow/canvas/save.json',
      saveCover: '/workflow/canvas/save_cover.json',
      workFlowList: '/workflow/canvas/list.json',
      workFlowInfo: '/workflow/canvas/info.json',
      nodeList: '/workflow/node/list.json',
      nodeSave: '/workflow/node/save.json',
      nodeInfo: '/workflow/node/info.json',
      nodeMaterial: '/workflow/canvas/material.json',
      shareFlow: '/workflow/canvas/share.json',
      share_info: '/workflow/canvas/share_info.json',
      // sop节点后台
      saveSopWorkFlow: '/workflow/sop/save.json',
      workFlowSopInfo: '/workflow/sop/info.json',
      workFlowSopConfig: '/workflow/sop/config.json',
      communitySopSubmit: '/workflow/sop/submit.json',

      surverPopup: '/common/popup.json',
      shareConfig: '/workflow/canvas/share_config.json',
      // 首页案例分类
      homeFeaturedCaseCategory: '/common/flow_category.json',
      // 首页案例列表
      homeFeaturedCase: '/common/flow_cards.json',
      // 案例详情
      homeFeaturedCaseInfo: '/common/flow_card/info.json',
      // 首页产品运营手册
      activityList: '/activity/list.json',
      // 首页案列点赞
      homeFeatureLike: '/common/flow_card/action.json',
      // 热门prompt列表
      homePrompt: '/common/home_prompt.json',

      // Seedance 异步生视频
      seedanceSubmit: '/ai_async_task/submit.json',
      seedanceQuery: '/ai_async_task/query.json',
      seedanceList: '/ai_async_task/list.json',
      seedanceDelete: '/ai_async_task/delete.json',
      // Seedance 真人人像活体检测结果
      seedanceLivenessSessionCreate: '/seedance/compliance/portrait/session/create.json',
      seedanceLivenessNotify: '/seedance/compliance/portrait/liveness/notify.json',
      seedanceLivenessSessionStatus: '/seedance/compliance/portrait/session/status.json',
      seedancePortraitFolderCreate: '/seedance/compliance/portrait/folder/create.json',
      seedancePortraitFolderList: '/seedance/compliance/portrait/folder/list.json',
      seedancePortraitFolderDelete: '/seedance/compliance/portrait/folder/delete.json',
      seedancePortraitFolderRename: '/seedance/compliance/portrait/folder/rename.json',
      seedancePortraitUpload: '/seedance/compliance/portrait/upload.json',
      seedanceComplianceLibraryList: '/seedance/compliance/library/list.json',
      seedanceComplianceLibraryUpload: '/seedance/compliance/library/upload.json',
      seedanceComplianceUploadStatus: '/seedance/compliance/upload/status.json',
      seedanceComplianceLibraryDelete: '/seedance/compliance/library/delete.json',

      // 社区共创-发布提交
      communitySubmit: '/workflow/community/submit.json',
      // 社区分类
      communityCategory: '/common/community_category.json',
      // 社区列表
      communityList: '/common/community_cards.json',
      // 我用过的列表
      communityUsedList: '/workflow/community/used/list.json',
      // 发布列表
      communityPublishedList: '/workflow/community/list.json',
      // 案例/工作流/作品-详情
      communityInfo: '/workflow/community/info.json',
      // 执行后的保存--记录关系
      communitySave: '/workflow/community/save.json',
      // 案例配置
      communityConfig: '/workflow/community/config.json',
      // 案例分享
      communityShare: '/workflow/community/share.json',
      // Agent 广场列表
      agentShopList: '/agent_shop/list.json',
      // Agent 广场 — 我用过的
      agentShopMyUsed: '/agent_shop/my_used.json',

      // agent team
      submitAgentTeamRoom: '/api/room/submit', // 提交 Agent 团队消息流
      createAgentTeamRoom: '/api/room/create', // 创建 Agent 团队房间
      createAgentTeamStream: '/api/stream/create', // 创建 Agent 团队消息流
      replyAgentTeamStream: '/api/stream/reply', // 提交询问卡片回复
      cancelAgentTeamStream: '/api/stream/cancel', // 取消 Agent 团队消息流
      agentTeamMessageHistoryDetail: '/api/history/detail', // 房间历史消息
      agentTeamRecordList: '/api/history/list', // Agent Teams 列表（room_type=5）
      agentTeamModifyHistory: '/api/history/modify', // 修改 Agent 团队房间标题
      agentTeamFileSystemTree: '/api/file_system/tree', // 文件系统-获取房间文件列表，
      agentTeamDownloadUrlResolve: '/api/file_system/download_url_resolve', // 下载媒体 URL 解析
      createAgentTeamShareLink: '/api/share/create', // 生成分享短链
      resolveAgentTeamShareLink: '/api/share/resolve', // 通过短链获取 room_id
      agentTeamFlowToolEvent: '/api/canvas/event', // 画布编辑推送事件
      toolExecute: '/api/tool/execute', // 工具执行
      toolQuery: '/api/tool/query', // 工具查询
      markdownDiff: '/api/tool/text_diff', // 文本差异对比
      countcost: '/api/tool/countcost', // 计费查询
      roomCheck: '/api/room/check', // 检查房间是否存在
      roomSubmit: '/api/room/submit', // 提交房间
      mediaAnalysis: '/api/tool/media_analysis', // 获取图像理解描述，用于传给agent team
      artifactReport: '/api/history/artifact_report', // 上报给服务端的哪些产物已经上过画布，没有上过的，下次进入房间时，重新上画布（续传未上画布问题）
      textSafeCheck: '/api/sensitive/text', // 文本安审
      agentTeamSubscriptionProducts: '/api/commerce/subscription_products', // Agent Team 订阅商品列表
      agentTeamCoinProducts: '/api/commerce/coin_products', // Agent Team 代币商品列表
      agentTeamMembershipInfo: '/api/commerce/membership_info', // Agent Team 会员信息查询

      // agent team canvas v2
      canvasDataV2: '/studio/v2/canvas/get.json', // 获取 Agent 团队房间数据
      saveCanvasDataV2: '/studio/v2/canvas/save.json', // 保存 Agent 团队房间数据
      canvasShareV2: '/studio/v2/canvas/share.json', // 登记分享短链（room_id + short_link + client_id）
      uiConfig: '/common/ui_config.json', // agent team ui 配置

      // 资产库 - 文件夹
      assetLibraryFolderList: '/asset_library/folder/list.json',
      assetLibraryFolderCreate: '/asset_library/folder/create.json',
      assetLibraryFolderRename: '/asset_library/folder/rename.json',
      assetLibraryFolderPin: '/asset_library/folder/pin.json',
      assetLibraryFolderDelete: '/asset_library/folder/delete.json',
      assetLibraryFolderDownload: '/asset_library/folder/download.json',
      assetLibraryFolderDownloadStatus: '/asset_library/folder/download_status.json',
      // 资产库 - 资产（素材）
      assetLibraryAssetList: '/asset_library/asset/list.json',
      assetLibraryAssetSearch: '/asset_library/asset/search.json',
      assetLibraryAssetCreate: '/asset_library/asset/create.json',
      assetLibraryAssetStar: '/asset_library/asset/star.json',
      assetLibraryAssetDelete: '/asset_library/asset/delete.json',
      assetLibraryAssetAddToFolder: '/asset_library/asset/add_to_folder.json',
      assetLibraryAssetRemoveFromFolder: '/asset_library/asset/remove_from_folder.json',
      assetLibraryAssetBatchAction: '/asset_library/asset/batch_action.json',

      // 素材库 v3.1 - 文件夹（与 /asset_library 历史记录完全独立）
      mediaLibraryFolderCreate: '/media_library/folder/create.json',
      mediaLibraryFolderDelete: '/media_library/folder/delete.json',
      mediaLibraryFolderMove: '/media_library/folder/move.json',
      mediaLibraryFolderMoveStatus: '/media_library/folder/move/status.json',
      mediaLibraryFolderRename: '/media_library/folder/rename.json',
      mediaLibraryFolderTree: '/media_library/folder/tree.json',
      // 素材库 v3.1 - 素材
      mediaLibraryItemSave: '/media_library/item/save.json',
      mediaLibraryItemGet: '/media_library/item/get.json',
      mediaLibraryItemUpdate: '/media_library/item/update.json',
      mediaLibraryItemList: '/media_library/item/list.json',
      mediaLibraryItemRename: '/media_library/item/rename.json',
      mediaLibraryItemDelete: '/media_library/item/delete.json',
      mediaLibraryItemBatchAction: '/media_library/item/batch_action.json',
      // 素材库 v3.1 - 存储用量
      mediaLibraryStorageUsage: '/media_library/storage/usage.json',
      // 团队存储额度
      teamStorageInfo: '/team/storage/info.json',
      teamStorageContactSave: '/team/storage/contact/save.json',

      // 官方资产库
      officialAssetCategoryList: '/official_asset/category/list.json',
      officialAssetGenreList: '/official_asset/genre/list.json',
      officialAssetMaterialList: '/official_asset/material/list.json',
      officialAssetMaterialInfo: '/official_asset/material/info.json',
      officialAssetTagList: '/official_asset/tag/list.json',

      // IP 解析
      ipResolution: '/common/ip_resolution.json',

      // agent team 工作流 v3 画布·
      canvasConfigV3: '/v3/canvas/config.json', // 获取 Agent 团队工作流 v3 画布配置
      canvasDataV3: '/v3/canvas/data/get.json', // 获取 Agent 团队工作流 v3 画布数据
      saveCanvasDataV3: '/v3/canvas/data/save.json', // 保存 Agent 团队工作流 v3 画布数据
      shareCanvasDataV3: '/v3/canvas/share/info.json', // 获取 Agent 团队工作流 v3 分享短链数据
      canvasRoomInfoV3: '/v3/canvas/room/info.json', // 获取 Agent 团队工作流 v3 房间信息
      canvasRoomRenameV3: '/v3/canvas/room/rename.json', // 重命名 Agent 团队工作流 v3 房间
      canvasListV3: '/v3/canvas/list.json', // 按项目获取画布列表
      canvasCreateV3: '/v3/canvas/create.json', // 创建 / 绑定画布到项目
      canvasRenameV3: '/v3/canvas/rename.json', // 重命名画布
      canvasLockAcquireV3: '/v3/canvas/lock/acquire.json', // 个人版 · 获取画布编辑锁（页签互斥）
      canvasLockReleaseV3: '/v3/canvas/lock/release.json', // 个人版 · 释放画布编辑锁
      canvasLockRenewV3: '/v3/canvas/lock/renew.json', // 个人版 · 画布锁心跳 / 查状态
      canvasProjectListV3: '/v3/canvas/project/list.json', // 项目列表
      canvasProjectCreateV3: '/v3/canvas/project/create.json', // 创建 Agent 团队工作流 v3 项目
      canvasProjectUpdateV3: '/v3/canvas/project/update.json', // 更新 / 重命名项目
      canvasProjectDeleteV3: '/v3/canvas/project/delete.json', // 删除 Agent 团队工作流 v3 项目
      canvasPublishAuditSubmitV3: '/v3/canvas/publish/audit_submit.json', // 发布审核提交
      canvasPublishAuditStatusV3: '/v3/canvas/publish/audit_status.json', // 发布审核状态
      canvasPublishSubmitV3: '/v3/canvas/publish/submit.json', // 发布提交
      canvasPublishInfoV3: '/v3/canvas/publish/info.json', // 获取房间最新发布提交信息
      canvasPublishEditV3: '/v3/canvas/publish/edit.json', // 发布内容编辑
      canvasPublishListV3: '/v3/canvas/publish/list.json', // 发布内容列表
      canvasPublishCasePinV3: '/v3/canvas/publish/pin.json', // 发布内容置顶/取消置顶
      canvasPublishDeleteV3: '/v3/canvas/publish/delete.json', // 发布内容删除
      canvasMaterialStyleListV3: '/v3/canvas/material/style/list.json', // 画布风格素材列表
      canvasMaterialSceneListV3: '/v3/canvas/material/scene/list.json', // 画布场景素材列表
      canvasMaterialCharacterListV3: '/v3/canvas/material/character/list.json', // 画布角色素材列表
      canvasMaterialPropModelListV3: '/v3/canvas/material/prop_model/list.json', // 画布道具模型素材列表
      canvasMaterialPuppetModelListV3: '/v3/canvas/material/puppet_model/list.json', // 画布人偶模型素材列表
      canvasMaterialGeometryModelListV3: '/v3/canvas/material/geometry_model/list.json', // 画布几何模型素材列表
      canvasMaterialCameraPresetListV3: '/v3/canvas/material/camera_preset/list.json', // 画布相机机位预设素材列表
      canvasMaterialSkeletonParamListV3: '/v3/canvas/material/skeleton_param/list.json', // 画布骨骼参数素材列表
      canvasMaterialPosePresetListV3: '/v3/canvas/material/pose_preset/list.json', // 画布人偶姿势预设素材列表
      canvasMaterialMovingShotListV3: '/v3/canvas/material/moving_shot/list.json', // 画布运镜素材列表
      canvasMaterialLightingListV3: '/v3/canvas/material/lighting/list.json', // 画布打光素材列表
      canvasMaterialBgmListV3: '/v3/canvas/material/bgm/list.json', // 画布 BGM 素材列表
      canvasMaterialTtsTimbreListV3: '/v3/canvas/material/tts_timbre/list.json', // 画布 TTS 音色列表
      ttsTimbreFavorite: '/v3/canvas/material/tts_timbre/favorite.json', // 音色收藏
      ttsTimbreFavoriteList: '/v3/canvas/material/tts_timbre/favorite/list.json', // 音色收藏list
      canvasMaterialPresetNodeListV3: '/v3/canvas/material/preset_node/list.json', // 画布预设节点列表
      canvasPromptTemplateListV3: '/v3/canvas/material/prompt_template/list.json', // 画布提示词模板列表
      canvasShareV3: '/v3/canvas/share/create.json', // 登记分享短链（room_id + short_link + client_id）
      // 首页运营分类
      canvasHomeCategoriesV3: '/v3/canvas/home/categories.json', // 首页运营分类列表
      canvasHomeCasesListV3: '/v3/canvas/home/cases.json', // 首页分类类案例详情列表
      canvasHomeCaseV3: '/v3/canvas/home/case.json', // 首页分类类案例详情
      // 首页输入框 Skill 列表
      homeInputPrompt: '/v3/canvas/home/input_prompt.json',
      canvasDataForkV3: '/v3/canvas/share/fork.json', // 画布数据复制（分叉）
      // 画布收藏保存
      canvasFavoriteSaveV3: '/v3/canvas/favorite/save.json',
      canvasFavoriteListV3: '/v3/canvas/favorite/list.json',

      // 爆款模板列表
      effectTemplateList: '/v3/canvas/material/effect_template/list.json',
      // 视频压缩
      videoCompress: '/api/media/video_compress',

      /** ---- 团队版 ----- */
      teamList: '/team/list.json',
      teamCreate: '/team/create.json',
      teamCurrent: '/team/current.json', // 获取当前团队信息
      teamInfo: '/team/info.json', // 获取当前团队详情与商业快照
      teamSwitch: '/team/current/switch.json', // 切换团队
      teamUpdate: '/team/update.json', // 更新团队名称或头像
      teamDissolve: '/team/dissolve.json', // 解散免费团队
      teamLeave: '/team/leave.json', // 普通成员退出团队
      teamMembers: '/team/members.json',
      teamMemberCreditQuotaSave: '/team/member/credit_quota/save.json', // 保存团队成员本月积分额度
      teamMemberRemove: '/team/member/remove.json', // 移出团队成员
      teamMemberTransferAdmin: '/team/member/transfer_admin.json', // 转让团队管理员
      teamSettings: '/team/settings.json', // 获取团队权限设置
      teamSettingsUpdate: '/team/settings/update.json', // 更新团队权限设置
      teamInvite: '/team/invite.json', // 获取或生成当前团队永久邀请码
      teamInvitePeek: '/team/invite/peek.json', // 登录后预览邀请团队信息
      teamJoinApply: '/team/join/apply.json', // 申请加入邀请对应的团队
      teamJoinRequests: '/team/join/requests.json', // 获取团队加入申请审核消息
      teamJoinReview: '/team/join/review.json', // 审核团队加入申请
      teamImportAssets: '/team/import/assets.json', // 从个人资产导入到当前团队
      teamImportProjects: '/team/import/projects.json', // 从个人项目导入到当前团队
      /** 团队版 · 画布 / 项目（需 Client-OID） */
      teamHomeList: '/team/home/list.json',
      teamFolderCreate: '/team/folder/create.json',
      teamFolderDelete: '/team/folder/delete.json',
      teamFolderProjectMove: '/team/folder/project/move.json',
      teamFolderUpdate: '/team/folder/update.json',
      teamCanvasCreate: '/team/canvas/create.json',
      teamCanvasDelete: '/team/canvas/delete.json',
      teamCanvasDuplicate: '/team/canvas/duplicate.json',
      teamCanvasList: '/team/canvas/list.json',
      teamCanvasLockAcquire: '/team/canvas/lock/acquire.json',
      teamCanvasLockRelease: '/team/canvas/lock/release.json',
      teamCanvasLockRenew: '/team/canvas/lock/renew.json',
      teamCanvasRename: '/team/canvas/rename.json',
      teamProjectDelete: '/team/project/delete.json',
      teamProjectDuplicate: '/team/project/duplicate.json',
      teamProjectList: '/team/project/list.json',
      teamProjectUpdate: '/team/project/update.json',
    },
  },
};

export default APP;
